import Box from "@mui/material/Box";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Typography from "@mui/material/Typography";
import CropLandscapeIcon from "@mui/icons-material/CropLandscape";
import CropPortraitIcon from "@mui/icons-material/CropPortrait";

interface BannerToggleProps {
  activeImageType: "horizontal" | "vertical";
  onImageTypeChange: (type: "horizontal" | "vertical") => void;
  hasHorizontalImage: boolean;
  hasVerticalImage: boolean;
}

export function BannerToggle({
  activeImageType,
  onImageTypeChange,
  hasHorizontalImage,
  hasVerticalImage,
}: BannerToggleProps) {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 8,
        left: 8,
        zIndex: 2,
      }}
    >
      <ToggleButtonGroup
        value={activeImageType}
        exclusive
        onChange={(_, newActiveImageType) => {
          if (newActiveImageType !== null) {
            onImageTypeChange(newActiveImageType);
          }
        }}
        aria-label="image type selection"
        size="small"
        sx={{
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          borderRadius: 1,
          "& .MuiToggleButton-root": {
            color: "white",
            border: "none",
            position: "relative",
            "&.Mui-selected": {
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              color: "black",
            },
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.1)",
            },
            "&.Mui-selected:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.9)",
            },
          },
        }}
      >
        <ToggleButton value="horizontal" aria-label="horizontal image 16:9">
          {hasHorizontalImage && (
            <Box
              sx={{
                position: "absolute",
                top: 2,
                right: 2,
                width: 6,
                height: 6,
                backgroundColor: "#4caf50",
                borderRadius: "50%",
                border: "1px solid rgba(255, 255, 255, 0.8)",
              }}
            />
          )}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "2px",
            }}
          >
            <CropLandscapeIcon fontSize="small" />
            <Typography
              variant="caption"
              sx={{ fontSize: "9px", lineHeight: 1 }}
            >
              16:9
            </Typography>
          </Box>
        </ToggleButton>
        <ToggleButton value="vertical" aria-label="vertical image 2:3">
          {hasVerticalImage && (
            <Box
              sx={{
                position: "absolute",
                top: 2,
                right: 2,
                width: 6,
                height: 6,
                backgroundColor: "#4caf50",
                borderRadius: "50%",
                border: "1px solid rgba(255, 255, 255, 0.8)",
              }}
            />
          )}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "2px",
            }}
          >
            <CropPortraitIcon fontSize="small" />
            <Typography
              variant="caption"
              sx={{ fontSize: "9px", lineHeight: 1 }}
            >
              2:3
            </Typography>
          </Box>
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}
